import React from 'react';
import Container from 'components/UI/Container';
import Title from 'components/UI/Title';
import { Grid, GridItem } from 'components/UI/Grid';
import BulletsCard from './BulletsCard';
import MobileSlider from 'components/MobileSlider';
import { withErrorBoundary } from 'components/ErrorBoundary';

import * as styles from './Bullets.module.scss';

const gridSettings = {
  xsm: { cols: 1 },
  sm: { cols: 3 },
  md: { cols: 3 },
  lg: { cols: 3 },
  xl: { cols: 3, gutterX: '14px', gutterY: '14px' },
  gutterX: '20px',
  gutterY: '20px',
};

function Bullets({ title, items, className }) {
  return (
    <Container id="feature" className={className}>
      <div className={styles.layout}>
        {title && (
          <Title className={styles.title} tag="h2" size="h3">
            {title}
          </Title>
        )}
        <div className={styles.desktopWrapper}>
          <Grid {...gridSettings}>
            {items.map(item => (
              <GridItem key={item.description}>
                <BulletsCard {...item} />
              </GridItem>
            ))}
          </Grid>
        </div>
        <MobileSlider
          className={styles.mobileWrapper}
          id="bulletsSlide"
          items={items}
          CardComponent={BulletsCard}
        />
      </div>
    </Container>
  );
}

Bullets.displayName = 'Bullets';

export default withErrorBoundary(Bullets);
